import { forwardRef } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/cn.js";

/**
 * Native <select> wrapper styled to match Input. We use the native control
 * (not a custom popover) for accessibility and reliable mobile UX.
 */
export const Select = forwardRef(
  ({ label, error, hint, className, id, required, children, ...props }, ref) => {
    const inputId = id ?? `sel-${Math.random().toString(36).slice(2, 8)}`;
    return (
      <div className="space-y-1.5">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-xs font-medium uppercase tracking-wider text-text-secondary"
          >
            {label}
            {required && <span className="ml-1 text-danger">*</span>}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            id={inputId}
            className={cn(
              "w-full appearance-none rounded-md border bg-bg-elevated px-3 py-2 pr-9 text-sm text-text-primary",
              "focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent",
              error ? "border-danger focus:border-danger focus:ring-danger" : "border-border",
              className
            )}
            {...props}
          >
            {children}
          </select>
          <ChevronDown
            aria-hidden
            className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-muted"
          />
        </div>
        {error && <p className="text-xs text-danger">{error}</p>}
        {!error && hint && <p className="text-xs text-text-muted">{hint}</p>}
      </div>
    );
  }
);
Select.displayName = "Select";
